/**
 * @generated SignedSource<<686356e2f1bb7b7bb19606179ab6ce98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IdentityProviders_query$data = {
  readonly samlProviders: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"IdentityProviderCard_provider">;
  }>;
  readonly " $fragmentType": "IdentityProviders_query";
};
export type IdentityProviders_query$key = {
  readonly " $data"?: IdentityProviders_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"IdentityProviders_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IdentityProviders_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SAMLProvider",
      "kind": "LinkedField",
      "name": "samlProviders",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IdentityProviderCard_provider"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "54ef4dc9d9184409b185c08a56bda60b";

export default node;
